import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Category from "./Components/Category";
import FoodDescription from "./Components/FoodDescription";
import Snackbar from "@mui/material/Snackbar";
import Nav from "./Components/Nav";
import OrderList from "./Components/OrderList";
import MerchantInfo from "./Components/MerchantInfo";
import Reports from "./Components/Reports";
import { useEffect, useState } from "react";
import axios from "axios";
import TableView from "./Components/TableView";
import ReactLoading from "react-loading";
import configs, { getParameterByName } from "./Constants";
//import Setting from "./Components/Setting";
import Epos from "./Components/Epos";
import DashBoard from "./Components/Dashboard";
import Customers from "./Components/Customers";
import Members from "./Components/Members";
import Variety from "./Components/variety";
import QRCodes from "./Components/QRCodes";
import SettingNew from "./Components/SettingNew";
import Offers from "./Components/Offers";
import Help from "./Components/Help";
import MemberProducts from "./Components/MemberProducts";
import Cl_Dashboard from "./clover/Dashboard";
import Cl_Categories from "./clover/Category";
import Cl_Fooddescription from "./clover/FoodDescription";
import RolesLogin from "./Components/RolesLogin";
import BillPrint from "./Components/BillPrint";
import MemberTables from "./Components/MemberTables";
import AppPage from "./Components/AppPage";
import { db } from "./root/util";
import { onValue, ref } from "firebase/database";
import { useIntl } from "react-intl";
import Promotion from "./Components/Promotion";
import Inventories from "./Components/Inventories";
import { Kitchen } from "@mui/icons-material";
import KitchenAssign from "./Components/KitchenAssign";
import { UserPermissionsProvider } from "./context/UserPermissionsContext";
import Dialog from "@mui/material/Dialog";
import AudioManager from "./Components/AudioManager";

function App() {
  const [notification, setNotification] = useState(false);
  const [refesh, setRefesh] = useState("");
  const [userSets, setUserSets] = useState(null);
  const [thirdParty, setThirdParty] = useState(null);
  const [isEpos, setIsEpos] = useState(true);
  const [openSetting, setOpenSetting] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const { formatMessage: t, locale, setLocale } = useIntl();
  const [openPairingDialog, setOpenPairingDialog] = useState(true);
  const [navKey, setNavKey] = useState(0);
  let isOrderFbCalled = false;
  let isTblFbCalled = false;
  let isOrderTempFbCalled = false;
  let isOrderUpdateFbCalled = false;
  const [userData, setUserData] = useState(
    localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : ""
  );
  const terminalProviders = ['verifone', 'worldline', 'stripe', 'powertranz'];

  const url_token = getParameterByName("token");
  let userToken = url_token
    ? url_token
    : localStorage.getItem("token")
      ? localStorage.getItem("token")
      : "";
  const imuserDetails = null;
  let tokenUrl = configs.authapi + "/user/validate-token";
  //  let tokenUrl="http://15.204.58.171:6004/user/validate-token";

  let baseURL = configs.baseURL;
  if (url_token) {
    localStorage.setItem("token", userToken);
    window.location.href = window.location.origin + "/";
  }

  useEffect(() => {
    console.log("========================== token check");
    console.log(userToken);
    console.log(userData);
    if (!userToken || !userData) return;
    console.log("**********************************");
    axios
      .get(`${configs.baseURL}/api/settings/${userData && userData.isIAM ? userData.parentUser : userData.sub}`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      })
      .then((resset) => {
        if (resset.status !== 200 || !resset.data.length) {
          setOpenSetting(true);
          return;
        }

        console.log(resset);
        localStorage.setItem(
          "merchantData",
          JSON.stringify(resset.data[0])
        );
        let merchantDtl = localStorage.getItem("merchantData");
        merchantDtl = JSON.parse(merchantDtl);
        setUserSets(merchantDtl);

        let settingInfo = merchantDtl;

        // move recent data to history at midnight
        //axios.get(`${configs.baseURL}/api/settings/${settingInfo?.id}/action/move_orders_to_backup`);
        //fb listener for orders
        movePreviousOrders(settingInfo);


        if (merchantDtl.activeProviderId) {
          axios
            .get(
              baseURL + "/api/thp-source/" + merchantDtl.activeProviderId
            )
            .then((res) => {
              setThirdParty(res.data);
            });


        }
      })
      .catch((err) => {
        console.error(err);
        setOpenSetting(true);
      });

    AudioManager.init({
      noti_sound: './update.mp3',
      temp_ord_sound: './landline_phone_ring.mp3',
      tbl_call_sound: './table-call.mp3'
    });

    const unlockAudio = () => {
      AudioManager.unlock();
      document.removeEventListener('click', unlockAudio);
      document.removeEventListener('touchstart', unlockAudio);
    };
    document.addEventListener('click', unlockAudio);
    document.addEventListener('touchstart', unlockAudio);

    return () => {
      document.removeEventListener('click', unlockAudio);
      document.removeEventListener('touchstart', unlockAudio);
    };
  }, []);

  const movePreviousOrders = (settingInfo) => {
    axios.get(`${configs.baseURL}/api/settings/${settingInfo?.id}/action/move_orders_to_backup`);
  }

  const initFBListner = (userSets, userData) => {
    if (userData && userData.role == 'SUPER-ADMIN') {
      const query = ref(db, "tempOrders");
      onValue(query, (snapshot) => {
        if (isOrderFbCalled) {
          const data = snapshot.val();

          try {
            AudioManager.play('noti_sound').then(() => setSnackbarOpen(true));
          } catch (e) {
            console.log("Audio play error:", e);
          }
          window.dispatchEvent(new Event('refresh_orders'));
        } else {
          isOrderFbCalled = true;
        }

      }, (error) => {
        console.error(error);
      });
    }
    else if (userSets && userSets.merchantCode) {
      console.log('++++FB REGISTERED*********************', userSets.merchantCode);

      const query = ref(db, "orders/" + userSets.merchantCode);
      onValue(query, (snapshot) => {
        if (isOrderFbCalled) {
          const data = snapshot.val();

          try {
            AudioManager.play('noti_sound').then(() => setSnackbarOpen(true));
          } catch (e) {
            console.log("Audio play error:", e);
          }
          window.dispatchEvent(new Event('refresh_orders'));
        } else {
          isOrderFbCalled = true;
        }


      }, (error) => {
        console.error(error);
      });

      const tempQuery = ref(db, "tempOrders/" + userSets.merchantCode);
      onValue(tempQuery, (snapshot) => {
        if (isOrderTempFbCalled) {
          const data = snapshot.val();

          try {
            AudioManager.play('temp_ord_sound').then(() => setSnackbarOpen(true));
          } catch (e) {
            console.log("Audio play error:", e);
          }
          window.dispatchEvent(new Event('refresh_orders'));
        } else {
          isOrderTempFbCalled = true;
        }

      }, (error) => {
        console.error(error);
      });

      const orderUpdateQuery = ref(db, "ordersUpdate/" + userSets.merchantCode);
      onValue(orderUpdateQuery, (snapshot) => {
        if (isOrderUpdateFbCalled) {
          const data2 = snapshot.val();
          window.dispatchEvent(new Event('refresh_orders'));
          document.querySelector('#temp_ord_sound').pause();
        } else {
          isOrderUpdateFbCalled = true;
        }


      }, (error) => {
        console.error(error);
      });

      //fb listener for tables request
      const tbquery = ref(db, "tables/" + userSets.merchantCode);
      return onValue(tbquery, (snapshot) => {
        //const data = snapshot.val();
        if (isTblFbCalled) {
          AudioManager.play('tbl_call_sound').catch(error => {
            // Autoplay was prevented.
          });
        }
        else {
          isTblFbCalled = true;
        }

      });

    }
  }


  useEffect(() => {
    initFBListner(userSets, userData);
  }, [userSets]);

  const handleNotification = () => {
    setNotification(true);
  };

  const handleRefresh = () => {
    refesh ? setRefesh("") : setRefesh("DATA REFRSHED");
  };

  let isBill = localStorage.getItem("billing");
  console.log(isBill)
  return (
    <UserPermissionsProvider>
      <Router>
        {isBill === "true" ? (
          <Routes>
            <Route exact path="/BillPrint" element={<BillPrint />} />
          </Routes>
        ) : (
          <Nav
            key={navKey}
            handleNotification={handleNotification}
            handleRefresh={handleRefresh}
            isEpos={isEpos}
            setIsEpos={setIsEpos}
          />
        )}
        {getParameterByName("merchantCode") && (
          <Routes>
            <Route exact path="/" element={!userData ? <RolesLogin /> : <OrderList
              notification={notification}
              setNotification={setNotification}
              refesh={refesh}
            />} />
            <Route exact path="/dashboard" element={<DashBoard />} />
            <Route exact path="/categories" element={<Category />} />
            <Route exact path="/varieties" element={<Variety />} />
            <Route exact path="/productDetails" element={<FoodDescription />} />
            <Route exact path="/productDetailsmember" element={<MemberProducts />} />
            <Route exact path="/tableMember" element={<MemberTables />} />
            <Route
              exact
              path="/orderList"
              element={
                <OrderList
                  notification={notification}
                  setNotification={setNotification}
                  refesh={refesh}
                />
              }
            />
            <Route exact path="/merchantInfo" element={<MerchantInfo />} />
            <Route exact path="/reports" element={<Reports />} />
            <Route exact path="/table" element={<TableView />} />
            <Route exact path="/setting" element={<SettingNew />} />
            <Route
              exact
              path="/epos/:oid"
              element={<Epos setIsEpos={setIsEpos} />}
            />
            <Route
              exact
              path="/epos"
              element={<Epos setIsEpos={setIsEpos} />}
            />

            <Route exact path="/customers" element={<Customers />} />
            <Route exact path="/members" element={<Members />} />
            <Route exact path="/qrcodes" element={<QRCodes />} />
            <Route exact path="/help" element={<Help />} />
            <Route exact path="/promotion" element={<Promotion />} />
            <Route exact path="/offers" element={<Offers />} />
            <Route exact path="/kitchen" element={<KitchenAssign />} />
            <Route exact path='/inventories' element={<Inventories />} />
            <Route exact path="/app" element={<AppPage />} />
          </Routes>
        )}

        {userSets &&
          userSets.activeProviderId &&
          thirdParty &&
          !getParameterByName("merchantCode") && (
            <Routes>
              <Route exact path="/" element={<Cl_Dashboard />} />
              <Route exact path="/dashboard" element={<Cl_Dashboard />} />
              <Route exact path="/categories" element={<Cl_Categories />} />
              <Route
                exact
                path="/productDetails"
                element={<Cl_Fooddescription />}
              />
              <Route exact path="/setting" element={<SettingNew />} />
              <Route exact path="/promotion" element={<Promotion />} />
              <Route exact path="/table" element={<TableView />} />
              <Route exact path="/members" element={<Members />} />
              <Route exact path="/orderList" element={<OrderList />} />
              <Route
                exact
                path="/epos/:oid"
                element={<Epos setIsEpos={setIsEpos} />}
              />
              <Route
                exact
                path="/epos"
                element={<Epos setIsEpos={setIsEpos} />}
              />

              <Route exact path="/qrcodes" element={<QRCodes />} />
            </Routes>
          )}

        {userSets &&
          !userSets.activeProviderId &&
          !getParameterByName("merchantCode") && (
            <Routes>
              <Route exact path="/" element={<DashBoard />} />
              <Route exact path="/dashboard" element={<DashBoard />} />
              <Route exact path="/categories" element={<Category />} />
              <Route exact path="/varieties" element={<Variety />} />
              <Route
                exact
                path="/productDetails"
                element={<FoodDescription />}
              />
              <Route
                exact
                path="/orderList"
                element={
                  <OrderList
                    notification={notification}
                    setNotification={setNotification}
                    refesh={refesh}
                  />
                }
              />
              <Route exact path="/merchantInfo" element={<MerchantInfo />} />
              <Route exact path="/reports" element={<Reports />} />
              <Route exact path="/table" element={<TableView />} />
              <Route exact path="/setting" element={<SettingNew />} />
              <Route
                exact
                path="/epos/:oid"
                element={<Epos setIsEpos={setIsEpos} />}
              />
              <Route
                exact
                path="/epos"
                element={<Epos setIsEpos={setIsEpos} />}
              />

              <Route exact path="/customers" element={<Customers />} />
              <Route exact path="/members" element={<Members />} />
              <Route exact path="/qrcodes" element={<QRCodes />} />
              <Route exact path="/help" element={<Help />} />
              <Route exact path="/promotion" element={<Promotion />} />
              <Route exact path="/offers" element={<Offers />} />
              <Route exact path="/kitchen" element={<KitchenAssign />} />
              <Route exact path='/inventories' element={<Inventories />} />
              <Route exact path="/app" element={<AppPage />} />
            </Routes>
          )}
        {!userSets && openSetting && (
          <Routes>
            <Route exact path="/" element={<SettingNew />} />
          </Routes>
        )}
      </Router>
      {/* {terminalProviders.indexOf(userData.paymentProviderType) !== -1 && <Dialog
        open={openPairingDialog}
        onClose={() => setOpenPairingDialog(false)}
        style={{ zIndex: 9999999 }}
      >
      <div style={{height:"500px"}}>
                <iframe id="pairFrame" src="https://vcloud-dev.alt-payment.com/webint/config/NextOrder/4dd84130-5982-4303-aa9f-3824f80c37cf?register_id=2323&merchant_id=qw22&merchant_name=nextpso" frameborder="0" allowtransparency="true" style={{width:"100%", height:"100%"}}></iframe>
            </div>
      </Dialog>} */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        message={t({ id: "order_update" })}
      />
    </UserPermissionsProvider>
  );
}

export default App;
